<template>
	<flexbox :class="{ 'is-unread' :data.is_read == 0 }" class="message-cell" align="stretch">
		<div class="message-cell__hd">
			<i :class="typeObj.icon" />
		</div>

		<div class="message-cell__bd">
			<span>{{ leftContent }}</span>
			<span :class="[{ 'is-invalid': isInvalid }, 'click-content']" @click="enterDetail">{{ centerCotent }}</span>
			<span>{{ rightContent }}</span>
		</div>

		<div class="message-cell__ft">
			<div>{{ data.create_time  }} </div>
			<div class="handle">
				<span class="check" @click="messageReadClick">标记已读</span>
				<span class="delete" @click="messageDeleteClick">删除</span>
			</div>
		</div>
	</flexbox>
</template>

<script>
	// import moment from 'moment'
	export default {
		// 消息cell
		name: 'MessageCell',
		components: {

		},
		props: {
			data: Object,
			dataIndex: [String, Number]
		},
		data() {
			return {}
		},
		computed: {
			typeObj() {
				const typesObj = {
					customer: {
						icon: 'wukong wukong-customer',
						color: '#6995FF',
						type: 'customer'
					},
					lawcase: {
						icon: 'wukong wukong-product',
						color: '#6995FF',
						type: 'lawcase'
					},
					contract: {
						icon: 'wukong wukong-contract',
						color: '#6995FF',
						type: 'contract'
					},
					finance: {
						icon: 'wukong wukong-pay',
						color: '#6995FF',
						type: 'finance'
					}
				}

				// 1 客户 2 案件 3顾问 4财务
				let key = ''
				if (this.data.label) {
					
				} else {
					if ([1].includes(this.data.type)) {
						key = 'customer'
					}else if ([2].includes(this.data.type)) {
						key = 'lawcase'
					}else if ([3].includes(this.data.type)) {
						key = 'contract'
					}else if ([4].includes(this.data.type)) {
						key = 'finance'
					}else if ([5].includes(this.data.type)) {
						key = 'finance'
					}else if ([6].includes(this.data.type)) {
						key = 'finance'
					}else if ([7].includes(this.data.type)) {
						key = 'finance'
					}
				}

				return typesObj[key]
			},

			leftContent() {
				return {
					1: `您被分配有新的客户`,
					2: `您有新的案件`,
					3: `您有新的顾问`,
					4: `您有新的收款信息`,
					5: `您的收款已完成审核`,
					6: `您有一条新的费用申请`,
					7: `您有一条费用申请已完成审核`,
				} [this.data.type]
			},

			centerCotent() {
				return `《${this.data.title}》`
			},

			isInvalid() {
				return false
			},

			rightContent() {
				return {
					1: `，请及时跟进！`,
					2: `，请及时跟进！`,
					3: `，请及时跟进！`,
					4: `，请知悉！`,
					5: `，请知悉！`,
					6: `，请审核！`,
					7: `，请知悉！`,
				} [this.data.type]
			}
		},
		watch: {},
		mounted() {},

		beforeDestroy() {},
		methods: {
			enterDetail() {
				if (this.isInvalid) {
					return
				}

				// 未读触发读
				if (this.data.is_read == 0) {
					this.$emit('read', this.data.id, this.dataIndex)
				}
				
				this.$emit('detail', this.typeObj.type, this.data.action_id, this.dataIndex, this.data)
			},

			/**
			 * 标记已读
			 */
			messageReadClick() {
				this.$emit('read', this.data.id, this.dataIndex)
			},

			/**
			 * 消息删除
			 */
			messageDeleteClick() {
				this.$emit('delete', this.data.id, this.dataIndex)
			},

			
		}
	}
</script>

<style lang="scss" scoped>
	.message-cell {
		position: relative;
		font-size: 14px;
		color: #333;
		padding: 15px 20px 15px 15px;
		line-height: 1.5;

		&__hd {
			flex-shrink: 0;
			margin-right: 15px;
			background-color: #2362FB;
			text-align: center;
			width: 28px;
			height: 28px;
			line-height: 28px;
			border-radius: 14px;

			.wk {
				color: white;
				font-size: 13px;
			}
		}

		&__bd {
			flex: 1;
			white-space: pre-wrap;
			word-wrap: break-word;
			word-break: break-all;
		}

		&__ft {
			flex-shrink: 0;
			font-size: 12px;
			color: #999;
			width: 85px;
			margin-left: 35px;
			text-align: right;
			position: relative;

			.handle {
				position: absolute;
				top: 20px;
				right: 0;
				font-size: 12px;
				color: #999;

				.check,
				.delete {
					visibility: hidden;
					cursor: pointer;
				}

				.check+.delete {
					margin-left: 5px;
				}

				.check:hover {
					color: #2362FB;
				}

				.delete:hover {
					color: #F56C6C;
				}
			}
		}

		&.is-unread::before {
			content: '';
			position: absolute;
			top: 20px;
			right: 8px;
			width: 6px;
			height: 6px;
			border-radius: 3px;
			background-color: #f94e4e;
		}

		&:hover {
			background-color: #f7f8fa;

			.delete {
				visibility: visible;
			}
		}

		&.is-unread:hover {
			.check {
				visibility: visible;
			}
		}
	}


	.click-content {
		color: #2362FB;
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
	}

	.is-invalid {
		color: #999;
		pointer-events: none;
		cursor: initial;
	}
	/deep/ .wukong{
		color:#ffffff;
	}
	/deep/ .message-cell__ft{
		width: 125px !important;
	}
</style>
